// @ts-nocheck
import * as helper from "./helper";
var EXPO_TYPE = helper.EXPO_TYPE;
export function intersectionExpo(entries, tracert) {
  var spmAPos = tracert.spmAPos,
    spmBPos = tracert.spmBPos;
  entries.forEach(function (entry) {
    var isIntersecting = entry.isIntersecting,
      intersectionRatio = entry.intersectionRatio,
      target = entry.target;
    // dom移除
    if (helper.isNoneDom(target, tracert.expoFixedDom)) {
      tracert.intersectionObserver.unobserve(target);
      return;
    }
    // spmId为null，没有曝光意义
    var spmOptions = helper.getSpmIdAndDom(target, spmAPos, spmBPos);
    var spmId = spmOptions.spmId,
      dom = spmOptions.dom;
    if (!spmId) {
      return;
    }
    var percent = 0;
    var nextStatus = EXPO_TYPE.DISAPPEAR;
    if (isIntersecting) {
      if (intersectionRatio === 1) {
        nextStatus = EXPO_TYPE.WHOLE;
      } else if (intersectionRatio >= 0.5) {
        nextStatus = EXPO_TYPE.HAFT;
      } else {
        nextStatus = EXPO_TYPE.START;
      }
      percent = Math.floor(100 * intersectionRatio);
    }
    var expoElDs = helper.getExpoDomDs(target, spmId, tracert._instanceId);
    var oldStatus = expoElDs.status;
    // 已经曝光过当前位置
    if (helper.expoSamePosition(nextStatus, oldStatus)) {
      return;
    }
    var combineType = 'auto';
    if (!helper.isEffectiveExpo(oldStatus) && helper.isEffectiveExpo(nextStatus)) {
      combineType = 'mix';
    }
    var options = {
      percent: percent,
      combineType: combineType,
      uuid: expoElDs.uuid,
      expoState: nextStatus === EXPO_TYPE.DISAPPEAR ? 'end' : 'start'
    };
    tracert._doExpo(spmId, dom, target, options, function () {
      expoElDs.status = helper.setExpoStatus(nextStatus, expoElDs.status);
    });
  });
}
export function createIntersection(callback, tracert) {
  if (!window.IntersectionObserver || !window.IntersectionObserverEntry) {
    return;
  }
  var options = {
    threshold: [0, 0.5, 1]
  };
  var intersect = new IntersectionObserver(function (entries) {
    callback(entries, tracert);
  }, options);
  return intersect;
}